import sectionHeader from './header/sectionHeader.vue';
import pageHeader from './header/pageHeader.vue'; 
import infoHeader from './header/infoHeader.vue';
import pageHeaderBtn from './buttons/pageHeaderBtn.vue';
import actionButton from './buttons/actionButton.vue';
import radioList from './form/radioList.vue'; 
import modal from './modal/modal.vue';

export default  {
    sectionHeader,
    pageHeader,
    infoHeader,
    pageHeaderBtn,
    actionButton,
    radioList,
    modal

};
